/**
 * store/modules/admin/adminPayout.js
 *
 * Vuex module handling admin payout state and actions.
 */
import axios from 'axios'

export default {
  // admin payout state.
  state: {
    adminPendingPurchases: [],
    adminPendingPurchaseRequest: {}
  },

  // Mutations to alter admin payout state.
  mutations: {
    setPendingPurchases: (state, statusList) => (state.adminPendingPurchases = statusList),
    setPendingPurchaseRequest: (state, request) => (state.adminPendingPurchaseRequest = request)
  },

  // Actions handling requests, and committing mutations.
  actions: {
    /**
     * Grab the payout pending list.
     */
    async getPendingPurchases ({ commit }) {
      try {
        let response = await axios.get('/api/admin/flip-ui/pending-purchase')
        // Payout list fetch success, set to state.
        commit('setPendingPurchases', response.data)
      }
      catch {
        // Payout list fetch failed.
        console.error('Unable to fetch pending purchases.')
      }
    },

    /**
     * Mark a pending payment as paid.
     *
     * lookup: string (required)
     */
    async markPendingPaymentAsPaid ({dispatch}, lookup) {
      try {
        await axios.post(`/api/admin/flip-ui/pending-purchase/${lookup}/confirm`)
        // Set as paid, refresh the list.
        dispatch('getPendingPurchases')
      }
      catch {
        // Payout resolution failed.
        console.error('Unable to mark request as paid.')
      }
    },

    /**
     * Mark a pending payment as canceled.
     *
     * lookup: string (required)
     */
    async markPendingPaymentAsCanceled ({dispatch}, lookup) {
      try {
        await axios.post(`/api/admin/flip-ui/pending-purchase/${lookup}/cancel`)
        // Set as paid, refresh the list.
        dispatch('getPendingPurchases')
      }
      catch {
        // Payout resolution failed.
        console.error('Unable to mark request as paid.')
      }
    }
  },

  // Payout state getters.
  getters: {
    adminPendingPurchases: state => state.adminPendingPurchases,
    adminPendingPurchaseRequest: state => state.adminPendingPurchaseRequest
  }
}
